<dls-dialog-content>
  <section class="dynamic-modal-content-container">
    <span class="dynamic-modal-content Auto_Popup_Text">{{content | translate:contentParams}}</span>
  </section>
</dls-dialog-content>
